const Footer = () => {
  return (
    <footer>
      <div className="text-center">
        <small>
          © <a href="/">Laser Octopus Club</a>
        </small>
      </div>
    </footer>
  );
};

export default Footer;
